import { ref } from "vue";

import { backendOld } from "~/api";

export const speechMessageDuid = ref<string | null>(null);
export const speechChatDuid = ref<string | null>(null);
export const speechStream = ref<MediaStream | null>(null);
export const speechPaused = ref(false);

let audio: HTMLAudioElement | null = null;
let audioContext: AudioContext | null = null;
let audioSource: MediaElementAudioSourceNode | null = null;

export const unlockSpeechAudio = () => {
  if (!audioContext) {
    audioContext = new AudioContext();
  }
  audioContext.resume();
  return audioContext;
};

export const stopSpeech = () => {
  if (audio) {
    audio.pause();
    audio.src = "";
    audio.load();
  }
  audioSource?.disconnect();
  audio = null;
  audioSource = null;
  speechMessageDuid.value = null;
  speechChatDuid.value = null;
  speechStream.value = null;
  speechPaused.value = false;
};

export const toggleSpeechPaused = () => {
  if (!audio) {
    return;
  }
  if (!audio.paused) {
    audio.pause();
    return;
  }
  unlockSpeechAudio();
  audio.play();
};

export const playSpeech = (messageDuid: string, chatDuid: string) => {
  stopSpeech();
  const element = new Audio();
  element.autoplay = true;
  const context = unlockSpeechAudio();
  const source = context.createMediaElementSource(element);
  const destination = context.createMediaStreamDestination();
  source.connect(context.destination);
  source.connect(destination);

  const stop = () => {
    if (audio === element) {
      stopSpeech();
    }
  };
  element.addEventListener("playing", () => {
    if (audio === element) {
      speechStream.value = destination.stream;
    }
  });
  element.addEventListener("pause", () => {
    if (audio === element) {
      speechPaused.value = true;
    }
  });
  element.addEventListener("play", () => {
    if (audio === element) {
      speechPaused.value = false;
    }
  });
  element.addEventListener("ended", stop);
  element.addEventListener("error", stop);

  audio = element;
  audioSource = source;
  speechMessageDuid.value = messageDuid;
  speechChatDuid.value = chatDuid;
  element.src = backendOld.chat.getMessageSpeechUrl(messageDuid);
};
